export default $trainingPeriod => {
  const getTrainingPeriod = () => $trainingPeriod.trainingPeriod
  return { getTrainingPeriod }
}
